module.exports = __webpack_public_path__ + "static/media/Sad Clown.37fae2e6.jpg";